import { render, staticRenderFns } from "./gradientsBar.vue?vue&type=template&id=a44f0f24"
import script from "./gradientsBar.vue?vue&type=script&lang=js"
export * from "./gradientsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a44f0f24')) {
      api.createRecord('a44f0f24', component.options)
    } else {
      api.reload('a44f0f24', component.options)
    }
    module.hot.accept("./gradientsBar.vue?vue&type=template&id=a44f0f24", function () {
      api.rerender('a44f0f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/bar/components/gradientsBar.vue"
export default component.exports